import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { environment } from "../../environments/environment";

@Injectable()
export class StagingGuard implements CanActivate {
  constructor(private router: Router) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    return environment.name === "dev" || environment.name === "staging";
  }
}



// WEBPACK FOOTER //
// ./src/app/_guards/staging.guard.ts